import { withPrefix } from "gatsby"

export function collectionFullSlugPrefixer(collection) {
  if (collection && collection.length && withPrefix("/") !== "/") {
    return collection.map((item) => {
      item.full_slug =
        item.full_slug.indexOf(process.env.GLOBAL_PATH_PREFIX) !== 0
          ? withPrefix(item.full_slug)
          : item.full_slug
      return item
    })
  } else {
    return collection
  }
}
